import { render } from "./MudaSenha.vue?vue&type=template&id=01ad4bea&scoped=true"
import script from "./MudaSenha.vue?vue&type=script&lang=js"
export * from "./MudaSenha.vue?vue&type=script&lang=js"

import "./MudaSenha.vue?vue&type=style&index=0&id=01ad4bea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ad4bea"]])

export default __exports__